export const combinations = [
    ["scissors", "paper"],
    ["paper", "rock"],
    ["rock", "scissors"]
]
